<template>
  <DropMedia
    :base-url="baseUrl"
  />
</template>

<script>
import DropMedia from '~/components/Drop_Media.vue'
import gtag from '~/plugins/gtagGA4.js'

export default {
  layout: 'media',
  components: {
    DropMedia
  },
  data () {
    return {
      dropId: this.$route.params.media
    }
  },
  asyncData ({ req, res }) {
    return {
      baseUrl:
          'https://' +
          (process.server ? req.headers.host : window.location.hostname)
    }
  },
  async mounted () {
    if (this.$auth.user) {
      this.$store.commit('user', this.$auth.user)
      await this.$store.commit('authToken', this.$auth.user.token)
    }
    gtag() // google analytics
  },
  head () {
    return {
      script: [
      ],
      link: [
        {
          rel: 'stylesheet',
          href: 'https://api.mapbox.com/mapbox-gl-js/v3.4.0/mapbox-gl.css'
        }
      ],
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: 'Drops'
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: 'Scan the QR code to check out this experience'
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: `https://wox-drops.s3.amazonaws.com/img/qr/${this.dropId}.png`
        },
        { property: 'og:image:width', content: '400' },
        { property: 'og:image:height', content: '400' }
      ]
    }
  }
}
</script>
